import React from 'react';
import styles from './styles.module.css';
import { Row, Col } from 'react-flexbox-grid';
import logo from '../../../assets/logo/logo-white.svg'
import * as Icon from '../../../components/Icons'
import * as PATHS from '../../../settings/paths';
import { Link } from 'react-router-dom';

const AuthWrapper = ({ footer = false, children }) => {
  return (
    <div className={styles.container}>
      <Row>
        <Col lg={5} xs={12} style={{ padding: 0 }}>
          <div className={styles.leftSide}>
            <div className={styles.overlay}></div>
            <div className={styles.content}>
              <div className={styles.logo}>
                <a href="/#">
                  <img src={logo} width="120px" alt="logo" />
                </a>
              </div>
              <div className={styles.welcome}>
                <h5>Welcome to</h5>
                <h1>HODHOD!</h1>
                <p>what was once a long and time-consuming process could be reduced to a few simple steps using</p>
                <a href="#/">hodhod.com</a>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={7} xs={12} style={{ padding: 0 }}>
          <div className={styles.rightSide}>
            <div className={styles.children}>
              {children}
              <div style={{ clear: "both" }}></div>
            </div>
            <div className={styles.footer}>
              <Row between>
                <Col lg={5} xs={12}>
                  <img src={'./assets/images/maqam-logo.png'} width="122px" alt="maqam" />
                  <div className={styles.links}>
                    {[
                      { name: 'Privacy Policy', path: PATHS.PRIVACY_POLICIES },
                      { name: 'Terms and Conditions', path: PATHS.TERMS_AND_CONDITIONS },
                      { name: 'Contact Us', path: PATHS.CONTACT_US },
                      { name: 'About Us', path: PATHS.ABOUT_US },
                    ].map((item, index) => (
                      <li>
                        <Link to={item.path}>{item.name}</Link>
                      </li>
                    ))}
                  </div>
                  <ul className={styles.socials}>
                    <li><Icon.Facebook /> </li>
                    <li><Icon.Twitter /></li>
                    <li><Icon.İnstagram /></li>
                  </ul>
                </Col>
                <Col lg={7} xs={12}>
                  <div className={styles.rightContent}>
                    <div className={styles.section}>
                      <h3>Planning a holiday just got easier.</h3>
                      <p>A few clicks and you’re done! Download our app now.</p>
                    </div>
                    <div className={styles.mobileAppIcon}>
                      <img src={'./assets/images/mobile-apps-dark.png'} alt="mobile-app-icons" />
                    </div>
                    <div className={styles.paymentIcon}>
                      <img src={'./assets/images/payment-icons.png'} alt="payment-icons" className={styles.paymentImage} />
                    </div>
                    <Row>
                      <div className={styles.copyright}>
                        <p>© {new Date().getFullYear()} <span style={{ color: 'var(--color-gold)' }}>Hodhod</span> - All Rights Reserved. Made by ideall technology</p>
                      </div>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>

  );
};

export default AuthWrapper;
